import React from "react";
import { Box, Typography } from "@mui/material";
import AboutSeller from "../../../components/seller/dashboard/AboutSeller";
import ActiveOrdersTable from "../../../components/seller/dashboard/ActiveOrdersTables";
import SellerDashboardMessegeList from "../../../components/seller/dashboard/MessegeList";
import SoldItemTable from "../../../components/seller/dashboard/SoldItemTable";

const SellerDashboard = () => {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, backgroundColor: "#111", minHeight: "100vh" }}>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 900, fontSize: { xs: "22px", md: "28px" }, color: "#fff", lineHeight: 1.2 }}>
          Seller <Box component="span" sx={{ color: "#FFC001" }}>Dashboard</Box>
        </Typography>
        <Typography sx={{ color: "#555", fontSize: "13px", mt: 0.5 }}>
          Manage your listings, reviews, and services
        </Typography>
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "300px 1fr" }, gap: 3, alignItems: "start" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <AboutSeller />
          <SellerDashboardMessegeList />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <SoldItemTable />
          <ActiveOrdersTable />
        </Box>
      </Box>
    </Box>
  );
};

export default SellerDashboard;
